import UpdateBannerModal from './UpdateBannerModal';

export default UpdateBannerModal;
